import(/* webpackMode: "eager" */ "/app/app/workspace/page.tsx");
